const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

export function isFinishedSessionNotesLocked(podSession) {
  if (podSession?.status !== "FINISHED") return false;
  if (!podSession?.updatedAt) return false;

  const updatedAtMs = new Date(podSession.updatedAt).getTime();
  if (Number.isNaN(updatedAtMs)) return false;

  return Date.now() - updatedAtMs > TWENTY_FOUR_HOURS_MS;
}

export function getEmailUsername(email) {
  return email?.split("@")[0] ?? "";
}

export function getProctorUsername(user, fallbackEmail) {
  const username = user?.username?.trim();
  return username || getEmailUsername(fallbackEmail ?? user?.email);
}

export function isUnclaimedProctor(proctor) {
  const value = String(proctor ?? "").trim().toUpperCase();
  return value === "" || value === "NULL" || value === "UNCLAIMED";
}

export function isClaimableProctor(proctor) {
  return isUnclaimedProctor(proctor);
}

export function getFieldValue(fields, key) {
  return fields?.find((field) => field.key === key)?.value ?? "";
}

export function getFieldValueIgnoreCase(fields, key) {
  const normalized = key.toLowerCase();
  return (
    fields?.find((field) => field.key?.toLowerCase() === normalized)?.value ??
    ""
  );
}

const PAYMENT_VALIDATION_FIELD_KEYS = [
  "receipt",
  "order",
  "code",
  "appointmentid",
];

const PAYMENT_VALIDATION_EXCLUDED_ORGANIZATION_NAMES = new Set([
  "Bossier Parish Community College - Math Department",
]);

export function isPaymentValidationExcludedForOrganization(organizationName) {
  return PAYMENT_VALIDATION_EXCLUDED_ORGANIZATION_NAMES.has(
    String(organizationName ?? "").trim(),
  );
}

export function shouldShowReceiptField(podSession, podNotesFormat) {
  return (
    podNotesFormat?.receipt === true &&
    !isPaymentValidationExcludedForOrganization(podSession?.organizationName)
  );
}

export function hasPaymentValidationFields(
  fields,
  podNotesFormat,
  organizationName,
) {
  if (isPaymentValidationExcludedForOrganization(organizationName)) {
    return false;
  }

  if (podNotesFormat?.receipt === true) return true;

  return (
    fields?.some((field) =>
      PAYMENT_VALIDATION_FIELD_KEYS.includes(field.key),
    ) ?? false
  );
}

const RECEIPT_FIELD_KEYS = ["receipt", "order", "code"];

export function getReceiptFromFields(fields) {
  for (const key of RECEIPT_FIELD_KEYS) {
    const value = getFieldValueIgnoreCase(fields, key);
    if (value) return value;
  }
  return "";
}

export function getPaymentReferenceId(fields) {
  return getReceiptFromFields(fields);
}

export const COLLEGE_BOARD_ORGANIZATION_ID = "college-board";

export function isCollegeBoardOrganization(organizationId) {
  return organizationId === COLLEGE_BOARD_ORGANIZATION_ID;
}

export function getKeycodeFromFields(fields) {
  return String(getFieldValueIgnoreCase(fields, "keycode") ?? "").trim();
}
